<template>
    <div>
        <div class='vx-col w-full mt-4' v-if="menu == 0">
            <div class="vx-row">
                <div class="vx-col w-full mb-4 mt-4">
                    <b class="m-3">Agregar imagen:</b>
                    <FileUploadVue ref="setImagen" class="mt-5" v-model="archivoMemoria" modelName="archivoMemoria" :ObjectSelected="Object(datosEvaluacion)" :id="datos.id" :carpeta="carpeta" :pesoImagen="pesoImagen" />
                    <!-- <vs-input type="file" accept="image/*" id="file-input" /> -->
                </div>
                <div class="vx-col w-1/2 boton-guardar">
                    <vs-button color="primary" @click="guardarFiles();">Guardar imagen</vs-button>
                </div>
            </div>
            <vs-divider></vs-divider>
            <div class="mostrar-imagenes">
                <!-- Mostrar imagenes seleccionadas -->
                <vs-table max-items="10" search pagination :data="ArrayListadoFiles">
                    <template slot="header">
                        <vs-chip  color="primary">Cantidad: <b> {{ ArrayListadoFiles.length }}</b></vs-chip>
                    </template>
                    <template slot="thead">
                        <vs-th>#</vs-th>
                        <vs-th>Archivo</vs-th>
                        <vs-th>Acciones</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                                {{ tr.id }}
                            </vs-td>
                            <vs-td>
                                <img v-if="tr.url!='' && tr.url!='null' && tr.url!=null" :src="$data_book+'archivos/'+carpeta+'/'+tr.url" class="img-responsive mt-5" width="80" height="80" style="border-radius: 5px;">
                            </vs-td>
                            <vs-td>
                                <vx-tooltip style="display: inline-block;" text="Eliminar nivel" position="top" color="primary">
                                    <vs-button class="modal-default-button" color="danger" @click="ObjectSelected=tr;menu = 1;" type="filled" icon-pack="feather" icon="icon-x-square"> </vs-button>
                                </vx-tooltip> &nbsp;
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>  
            </div>
        </div>
        <div v-if="menu == 1">
            <div class="mt-5">
                <p class="text-center font-bold">Estas seguro de eliminar la imagen</p>
                <div class="flex justify-center mt-3">
                    <img v-if="ObjectSelected.url!='' && ObjectSelected.url!='null' && ObjectSelected.url!=null" :src="$data_book+'archivos/'+carpeta+'/'+ObjectSelected.url" class="img-responsive mt-5" width="80" height="80" style="border-radius: 5px;">
                </div>
                <div class="flex justify-center mt-8">
                    <vs-button class="mr-3 mb-2" @click="f_delete_opcion();">Si, deseo eliminar</vs-button>
                    <vs-button color="warning" type="border" class="mb-2" @click="menu = 0;">Cancelar</vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const FileUploadVue = () => import('../../admin/reutilizable/Files/FileUpload.vue');
import GeneralMixin from "@/mixins/GeneralMixin.js";
export default {
    mixins: [GeneralMixin],
    props: {
        datosEvaluacion: {
            type: Object,
            default: () => {}
        },
        datos_editar: {
            type: Object,
            default: () => {}
        },
    },
    components: {
        FileUploadVue
    },
    data() {
        return {
            datos: {},
            archivoMemoria: null,
            carpeta: 'memoria',
            ObjectSelected: '',
            imgOld: '',
            //fin variables image,
            pesoImagen: 0.5,
            ArrayListadoFiles:[],
            id:0,
            menu:0,
        };
    },
    created() {},
    mounted() {
        let me = this
        me.getListadoFiles()
    },
    methods: {
        getListadoFiles(){
            let me = this
            me.$vs.loading();
            this.$http.get(this.$server_url+`juegosMetodosGet?getFilesJuegos=1&id_juego=${me.datos_editar.id}`)
                .then(function (res) {
                    me.ArrayListadoFiles = res.data
                    me.$vs.loading.close()
                })
                .catch(function (error) {
                    console.log(error + ' error');
                    me.$vs.loading.close()
                })
        },
        guardarFiles() {
            let me = this;
            //si el arrayListadoFiles es mayor a 10 no se puede guardar
            if (me.ArrayListadoFiles.length >= 10) {
                me.$vs.notify({
                    title: 'Error',
                    text: 'No se puede guardar más de 10 imágenes',
                    color: 'warning',
                    position: 'top-right'
                });
                return;
            }
            if (me.archivoMemoria == null || me.archivoMemoria == '' || me.archivoMemoria == undefined) {
                me.$vs.notify({
                    title: 'Error',
                    text: 'Debe seleccionar una imagen',
                    color: 'warning',
                    position: 'top-right'
                });
                return;
            }
            let formData = new FormData();
            formData.append('id',               me.id)
            formData.append('archivo1',         me.archivoMemoria)
            formData.append('imgOld',           me.imgOld)
            formData.append('ruta',             me.carpeta)
            //save en tabla
            //nombre modelo
            formData.append('nombreM',          "ArchivoFiles")
            formData.append('guardarTabla',     "1")
            //guardar id padre
            formData.append('guardarIdPadre',   "1")
            formData.append('id_padre',         me.datos_editar.id)
            formData.append('tipo',             0)
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            this.$http.post(this.$data_url + 'api/guardarDocumentos', formData, config)
                .then(() => {
                    me.f_notificaciones("Se guardo correctamente", "success");
                    me.archivoMemoria = null
                    me.getListadoFiles()
                    //ref setImagen activar el metodo limpiar
                    me.$refs.setImagen.limpiar()
                }).catch(() => {});
        },
        f_delete_opcion(){
            let me = this;
            let formData = new FormData();
            formData.append('id',                me.ObjectSelected.id)
            formData.append('ruta',              me.carpeta)
            //save en tabla
            //nombre modelo
            formData.append('nombreM',           "ArchivoFiles")
            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            me.$vs.loading();
            this.$http.post(this.$data_url + 'api/quitarArchivoIndividual', formData,config)
            .then((result) => {
                me.$vs.loading.close();
                me.f_notificaciones("Se elimino correctamente", "warning");
                me.menu = 0;
                me.getListadoFiles();
            }).catch((err) => {
                me.$vs.loading.close();
                me.$vs.notify({
                    title: 'Error',
                    text: 'Error al eliminar la imagen',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                });
            });
        },
    }
};
</script>
